import template from './teamRequestsModalApproveAllConfirm.html';
import controller from './teamRequestsModalApproveAllConfirm.controller';

let teamRequestsModalApproveAllConfirmComponent = {
  restrict: 'E',
  bindings: {
    onApproveAll: '&',
    isMobileApp: '<'
  },
  template,
  controller
};

export default teamRequestsModalApproveAllConfirmComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsModalApproveAll/teamRequestsModalApproveAllConfirm/teamRequestsModalApproveAllConfirm.component.js